<div class="row">
     <div class="col-12">
          <div class="row justify-content-between align-items-center" id="page-title">
               <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'">
                    Enroll in PSP
               </h1>
          </div>
          <div class="row mb-2">
               <span class="col-12 col-lg-auto d-flex align-items-center small">
                    <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
                    <span [innerHTML]="'Start_8-1' | translator:'base'">
                         Are you a <strong>driver</strong> looking for your own PSP record?
                    </span>
                    <a routerLink="/driver/1" (click)="scrollToTop()" name="Driver-record-request"
                         id="Driver-record-request" [title]="'Start_8-2' | translator:'base'" class="ms-1">
                         <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record
                              here.</span>
                    </a>
               </span>
          </div>
          <div class="row">
               <div class="col-lg-8">
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <app-complete-bar [step]="2" [totalSteps]="19"></app-complete-bar>
                              <h2 [innerHTML]="'BSCE_1' | translator:'base'">Background Screening Company Enrollment
                              </h2>
                              <p [innerHTML]="'BSCE_2' | translator:'base'">
                                   PSP calls companies like yours "industry service providers." The full definition of
                                   an industry service
                                   provider can be found in the enrollment agreement. You should download the agreement
                                   to thoroughly review
                                   all of your company's obligations with PSP. Many industry service providers want
                                   their legal
                                   representation to review the form prior to submitting it.
                              </p>
                              <hr>
                              <div class="box box-lined">
                                   <p class="text-lg">
                                        <label class="form-label w-100">
                                             <span [innerHTML]="'GSMAH_Review agreement' | translator:'base'">Review
                                                  enrollment agreement</span>
                                        </label>
                                        <button (click)="openDocument('ISPAccountHolderAgreement')"
                                             class="btn btn-primary" [title]="'GSMAH_EnrollmentAgreement' | translator:'base'"
                                             name="ispAgreement" id="ispAgreement">
                                             <span [innerHTML]="'GSMAH_EnrollmentAgreement' | translator:'base'">Enrollment
                                                  Agreement</span> (PDF)
                                        </button>
                                   </p>
                                   <p [innerHTML]="'BSCE_4' | translator:'base'">
                                        The agreement will open in a new tab. After you are finished reviewing the
                                        document, return here to
                                        finish the enrollment process.
                                   </p>
                              </div>
                              <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                                   <div class="btn-group" role="group">
                                        <button routerLink="/signup/5" class="btn btn-primary btn-strong"
                                             (click)="scrollToTop()" [title]="'ISPInfo' | translator:'base'"
                                             name="companyNext3" id="companyNext3">
                                             <span [innerHTML]="'Continue' | translator:'base'">Continue</span>
                                             <span class="sr-only">&nbsp;</span>
                                             <span class="sr-only" [innerHTML]="'ISPInfo' | translator:'base'">Industry
                                                  Service Provider
                                                  Info</span>
                                        </button>
                                   </div>
                                   <div class="btn-group" role="group">
                                        <button routerLink="/signup/1" class="btn btn-outline-primary"
                                             [title]="'BackToWelcome' | translator:'base'" name="companyBack3"
                                             id="companyBack3">
                                             <span [innerHTML]="'Back' | translator:'base'">Back</span>
                                             <span class="sr-only"
                                                  [innerHTML]="'GSMAH_Back to' | translator:'base'">Welcome</span>
                                        </button>
                                        <button routerLink="/" tag="button" class="btn btn-light"
                                             (click)="scrollToTop()" name="companyCancel3" id="companyCancel3"
                                             [innerHTML]="'Cancel' | translator:'base'"
                                             [title]="'Cancel' | translator:'base'"></button>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
               <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="1"
                    [pageType]="enrollment.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
          </div>
     </div>
     <app-spinner
          [isLoading] = isLoading
     ></app-spinner>
</div>